import { useEffect } from 'react';

const NSEC_PATTERN = /nsec1[a-z0-9]{58}/i;

/**
 * Prevent accidental paste of nsec into non-login fields.
 */
export function useNsecPasteGuard() {
  useEffect(() => {
    function handlePaste(e: ClipboardEvent) {
      const text = e.clipboardData?.getData('text');
      if (!text || !NSEC_PATTERN.test(text)) return;

      const target = e.target as HTMLElement;
      if (target.id === 'nsec' || target.closest?.('[data-nsec-allowed]')) return;

      e.preventDefault();
      e.stopImmediatePropagation();
      console.warn(
        '[OpenDork] Blocked paste of secret key outside the login field. ' +
          'Posting an nsec publicly could give someone full access to your account.',
      );
    }

    document.addEventListener('paste', handlePaste, { capture: true });
    return () => document.removeEventListener('paste', handlePaste, { capture: true });
  }, []);
}
